import { createRouter } from 'vue-router';

const routes = [
  { path: '/', redirect: '/upload' },
  { path: '/upload', name: 'upload', component: () => import('@vft/views/UploadView.vue') },
  { path: '/audit', name: 'audit', component: () => import('@vft/views/AuditView.vue') },
  { path: '/form', name: 'form', component: () => import('@vft/views/FormSelectView.vue') },
  { path: '/mapping', name: 'mapping', component: () => import('@vft/views/MappingView.vue') },
  { path: '/values', name: 'values', component: () => import('@vft/views/ValueMapView.vue') },
  { path: '/correction', name: 'correction', component: () => import('@vft/views/CorrectionView.vue') },
  { path: '/computed', name: 'computed', component: () => import('@vft/views/ComputedView.vue') },
  { path: '/export', name: 'export', component: () => import('@vft/views/ExportView.vue') },
];

export function createAppRouter(history) {
  return createRouter({ history, routes });
}
